import { elektraAppQueryOptions } from '@connected/elektra-sdk/queries/query-options';
import { Button } from '@connected/ui/components/button';
import { useQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';
import { ClipboardList } from 'lucide-react';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { getStatusLabel } from '../utils/project-status-utils';
import { StatusChangePopout } from './status-change-popout';

export function ProjectStatusMenuItem() {
    const [open, setOpen] = useState(false);
    const { t } = useTranslation('projects');

    const params = useParams({ from: '/(auth)/projects/$projectVersionId' });

    const { data: statusData } = useQuery(
        elektraAppQueryOptions.project.status({
            electricalProjectVersionId: params.projectVersionId,
        }),
    );

    const currentStatus = statusData?.Project?.Status ?? 'Request';

    const statusLabel = useMemo(
        () => getStatusLabel(statusData?.Project?.Status, t('status.inProgress')),
        [statusData?.Project?.Status, t],
    );

    return (
        <StatusChangePopout
            open={open}
            onOpenChange={setOpen}
            currentStatus={currentStatus}
            projectVersionId={params.projectVersionId}
            onSuccess={() => setOpen(false)}
        >
            <Button
                variant="ghost"
                className="justify-start gap-2"
                onClick={() => setOpen(true)}
            >
                <ClipboardList size={24} />
                <span>{t('userMenu.projectStatus', { status: statusLabel })}</span>
            </Button>
        </StatusChangePopout>
    );
}
